import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Spec from "csi/core/Spec";
import ColumnAssociation from "csi/table/matrix/ColumnAssociation";
import { pathCreate } from "csi/utility/pathUtility";
import declare from "dojo/_base/declare";

const ActivityMatrix = declare(ColumnAssociation, {
	bAllowColumnFilter: true,
	columnAssociation: "Master",
	columnPath: "Child:Master/Child:Activities",

	/**
	 * @override
	 * Add extra dependency path to support styling
	 */
	addDependencyPaths(h: Heading, paths: string[]): void {
		paths.push(pathCreate(this.columnPath, "Proto"));
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Add custom styling to columns
	 */
	onPathSpecParams(ctx: Context, params: Partial<Spec>, columnIndex?: number): void {
		const proto = ctx.getChildNode("Proto");

		if (proto.ActivityType === "ACTIVITYTYPE:Milestone") {
			this._addColumnCss(params.headerParams, "milestone");
		}
	},
});

export = ActivityMatrix;
